// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  style?: React.CSSProperties
  link?: string
  icon: string

  isTransparent?: boolean
  onClick?: () => void
}

const Icon: React.FC<PropsType> = (props) => {
  return (
    <a href={props.link} target="_blank" onClick={props.onClick}>
      <Wrapper
        style={{
          ...props.style,
          backgroundColor: props.isTransparent ? undefined : "#262f38",
        }}
      >
        <Container className={props.icon} />
      </Wrapper>
    </a>
  )
}

/////////////////////////////////////////////////////////////////////////////

const ICON_SIZE = "55px"
const Wrapper = styled.div`
  border-radius: 15px;
  cursor: pointer;
  font-size: 18pt;
  height: ${ICON_SIZE};
  margin: 0 15px;
  overflow: hidden;
  text-align: center;
  transition: background 0.3s, color 0.3s, box-shadow 0.3s, transform 0.3s;
  width: ${ICON_SIZE};
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  box-shadow: 0px 5px 3px rgba(0, 0, 0, 0.1),
    0px 20px 40px rgba(23, 0, 102, 0.2),
    inset 0px 0px 0px 0.5px rgba(255, 191919, 255, 0.5);

  &:hover {
    background: #5d4ca6;
    box-shadow: 0 0 0 3px rgba(4, 94, 201, 0.1);
    transform: translateY(-5px);
    box-shadow: 0px 10px 3px rgba(0, 0, 0, 0.1),
      0px 30px 60px rgba(23, 0, 102, 0.5),
      inset 0px 0px 0px 0.5px rgba(191919, 255, 255, 0.5);

    i {
      -webkit-animation: toBottomFromTop 0.3s forwards;
      -moz-animation: toBottomFromTop 0.3s forwards;
      animation: toBottomFromTop 0.3s forwards;
    }
  }
`

const Container = styled.i`
  color: #fff;
  text-align: center;
`

export default React.memo(Icon, memoComparison)
